// Error request bisa tanpa response: jaringan putus, dibatalin router, atau bug kode. Murni, nol import.

const statusOf = (e) => e?.response?.data?.status;

// Sama dengan axios.isCancel di axios 0.19.
export function isCancelled(e) {
  return Boolean(e && e.__CANCEL__);
}

export function isAuthError(e) {
  return statusOf(e)?.message === 'Authentication Error';
}

export function requestErrorMessage(e, fallback = 'Network error') {
  const message = statusOf(e)?.message;
  return typeof message === 'string' && message ? message : fallback;
}

// Pesan validasi datang sebagai {field: {rule: teks}}.
function messageText(message) {
  if (typeof message === 'string' && message) return message;
  if (!message || typeof message !== 'object') return 'Request failed';
  const texts = Object.values(message)
    .flatMap((rules) => (rules && typeof rules === 'object' ? Object.values(rules) : [rules]))
    .filter((text) => typeof text === 'string' && text);
  return texts.length ? texts.join('; ') : 'Request failed';
}

// body HTTP 200 berstatus gagal jadi Error ber-errorCode
export function bodyStatusError(body) {
  const status = body?.status;
  const failed = Boolean(Number(status?.error)) || Boolean(Number(status?.errorCode));
  if (!failed) return null;
  return Object.assign(new Error(messageText(status.message)), { errorCode: Number(status.errorCode) || 0 });
}
